import * as React from 'react';
import styled from 'styled-components';
import * as ReactMarkdown from 'react-markdown';
import { Parsers } from './Parsers';
import { Wysiwyg } from '../../atoms/Wysiwyg';
import { Margin } from '../../../utilities/margin';
import { GRID_UNIT } from '../../../utilities/grid';
import { Link } from '../../atoms/Link/Link';
import { Heading } from '../../atoms/Heading';
import { Icon } from '../../atoms/Icon';
import { Alert } from '../../atoms/Alert/Alert';
import { ImageFromCdn } from '../../atoms/ImageFromCdn';
import { Paragraph } from '../../atoms/Paragraph';
const Small = styled.small `
  font-size: 13px;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.neutral.dark};
`;
export class Markdown extends React.PureComponent {
    listRenderer(props) {
        if (props.ordered) {
            return (React.createElement(Margin, { bottom: GRID_UNIT },
                React.createElement(Wysiwyg, null,
                    React.createElement("ol", null, props.children))));
        }
        return (React.createElement(Margin, { bottom: GRID_UNIT },
            React.createElement(Wysiwyg, { tickmark: props.tickmark },
                React.createElement("ul", null, props.children))));
    }
    isUrlInternal(url) {
        return (url.startsWith('/') ||
            (url.includes('deeplink') &&
                (!url.startsWith('http') ||
                    url.includes('app.moneyfarm.com') ||
                    url.includes('app-test.moneyfarm.com') ||
                    url.includes('app-local.moneyfarm.com'))));
    }
    isModalUrl(url) {
        return url.startsWith('/modal/story/');
    }
    inlineLinkRenderer(props) {
        if (this.isModalUrl(props.href)) {
            const webStoryId = props.href.split('/').pop();
            return (React.createElement(Link, { role: "primary", onClick: () => {
                    const event = new CustomEvent('webStoriesLinkClick', {
                        detail: {
                            id: webStoryId,
                        },
                    });
                    dispatchEvent(event);
                }, target: "_self" }, props.children));
        }
        let target = '_blank';
        if (this.isUrlInternal(props.href)) {
            target = '_self';
        }
        return (React.createElement(Link, { role: "primary", href: props.href, target: target }, props.children));
    }
    standaloneLinkRenderer(props) {
        if (this.isUrlInternal(props.url)) {
            return (React.createElement(Link, { role: "primary", href: props.url, target: "_self", icon: "internal" }, props.children));
        }
        return (React.createElement(Link, { role: "primary", href: props.url, target: "_blank", icon: "external" }, props.children));
    }
    imageRenderer(props) {
        if (/^icon\|/i.test(props.src)) {
            const sprite = props.src.replace(/^icon\|/, 'icon-');
            return React.createElement(Icon, { sprite: sprite });
        }
        return React.createElement(ImageFromCdn, Object.assign({}, props));
    }
    paragraphRenderer(props) {
        return (React.createElement(Margin, { bottom: GRID_UNIT },
            React.createElement(Paragraph, null, props.children)));
    }
    headingRenderer(props) {
        if (props.level > 1 && props.level <= 4) {
            return (React.createElement(Margin, { top: GRID_UNIT * 4, bottom: GRID_UNIT },
                React.createElement(Heading, { level: props.level }, props.children)));
        }
        return this.paragraphRenderer(props);
    }
    blockquoteRenderer(props) {
        return (React.createElement(Margin, { top: GRID_UNIT, bottom: GRID_UNIT },
            React.createElement(Alert, { message: props.children, type: props.alertType })));
    }
    codeRenderer(props) {
        return (React.createElement(Margin, { top: GRID_UNIT, bottom: GRID_UNIT },
            React.createElement(Small, null, props.children)));
    }
    render() {
        const { markdown } = this.props;
        const renderers = {
            image: props => this.imageRenderer(props),
            link: props => this.inlineLinkRenderer(props),
            mfStandaloneLink: props => this.standaloneLinkRenderer(props),
            mfList: props => this.listRenderer(props),
            heading: props => this.headingRenderer(props),
            paragraph: props => this.paragraphRenderer(props),
            mfBlockquote: props => this.blockquoteRenderer(props),
            code: props => this.codeRenderer(props),
            inlineCode: props => this.codeRenderer(props),
        };
        const allowNode = (node, index, parent) => {
            // Inline images are not allowed
            if (node.type == 'image' &&
                parent.children &&
                parent.children.length > 1) {
                return false;
            }
            return true;
        };
        return (React.createElement(ReactMarkdown, { source: markdown, renderers: renderers, plugins: [Parsers.StandaloneLink, Parsers.List, Parsers.Blockquote], parserOptions: { commonmark: true }, allowNode: allowNode, disallowedTypes: [
                'html',
                'imageReference',
                'linkReference',
                'table',
                'tableBody',
                'tableCell',
                'tableHead',
                'tableRow',
                'definition',
                'virtualHtml',
            ] }));
    }
}
Markdown.defaultProps = {
    markdown: '',
};
//# sourceMappingURL=index.js.map